import React, { useEffect, useState } from "react";
import BreadCrumbBanner from "../../component/BreadCrumbBanner";
import facilitiesAPI from "../../api/facilitiesApi";

const KyanBoard = () => {
  const [kyanBoard, setKyanBoard] = useState([]);
  const [kyanBenefits, setKyanBenefits] = useState([]);

  useEffect(() => {
    fetchKyanBoard();
  }, []);

  const fetchKyanBoard = async () => {
    const res = await facilitiesAPI.kyan_smart();

    if (res.code === 200) {
      const result = res.data;
      setKyanBoard(result["kyan-smart"] || []);
      setKyanBenefits(result["kyan-benefits"] || []);
    }
  };

  const boardInfo = kyanBoard?.[0];
  const benefitsInfo = kyanBenefits?.[0];

  return (
    <>
      {/* BreadCrump Section */}
      <BreadCrumbBanner
        title="Kyan Smart Boards"
        backgroundImage={`${process.env.PUBLIC_URL}/assets/img/about-top2.webp`}
      />

      {/* kyan lab section */}
      {kyanBoard.length > 0 && (
        <section className="kyan-smart-section py-5">
          <div className="container">
            <div className="row align-items-center g-5">
              {/* LEFT : IMAGE */}
              <div className="col-lg-6 animate__animated animate__fadeInLeft">
                <div className="kyan-image-box">
                  <img
                    src={boardInfo?.image}
                    alt="Kyan Smart Class"
                    loading="lazy"
                  />
                </div>
              </div>
              {/* RIGHT : CONTENT */}
              <div className="col-lg-6 animate__animated animate__fadeInRight">
                <span className="mrv-subtitle">{boardInfo?.maintitle}</span>
                <h2 className="mrv-title">{boardInfo?.subtitle}</h2>
                <p className="kyan-desc">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: boardInfo?.description || "",
                    }}
                  />
                </p>
                <div className="kyan-features">
                  {boardInfo?.listings?.map((item, index) => (
                    <div className="kyan-feature">
                      <img className="library-icon" src={item.icon} loading="lazy" />
                      <div>
                        <h6>{item.listingtitle}</h6>
                        <p>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: item?.listingsubtitle || "",
                            }}
                          />
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Smart Learning Benefits */}
      {kyanBenefits.length > 0 && (
        <section className="kyan-benefits-section py-5 bg-light">
          <div className="container">
            <div className="row text-center mb-4">
              <div className="col-lg-8 mx-auto">
                <h2 className="mrv-title">{benefitsInfo?.maintitle}</h2>

                <div
                  dangerouslySetInnerHTML={{
                    __html: benefitsInfo?.description || "",
                  }}
                />
              </div>
            </div>

            <div className="row g-4">
              {benefitsInfo?.listings?.map((item, index) => (
                <div className="col-md-4">
                  <div className="acad-structure-card">
                    <h5>{item.title}</h5>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item?.shortdescription || "",
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default KyanBoard;
